export const CLIENT_INVITE_QUERY = 'brand';

export const getClientInviteToken = (search = '') => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const token = String(params.get(CLIENT_INVITE_QUERY) || '').trim();
  return token || null;
};

export const getTripInviteId = (search = '') => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const invite = String(params.get('invite') || '').trim();
  return /^\d+$/.test(invite) ? invite : null;
};

export const partnerAuthName = (branding) => {
  const name = String(branding?.name || '').trim();
  if (!name || branding.level === 'house') return null;
  return name;
};

export const withClientInviteQuery = (path, token, extra = {}) => {
  const params = new URLSearchParams();
  Object.entries(extra).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  if (token) params.set(CLIENT_INVITE_QUERY, token);
  const query = params.toString();
  return query ? `${path}?${query}` : path;
};
